<script>
export default {
  props: {
    tag: {
      default: 'div',
      type: String,
    },
    radius: {
      default: '10px',
      type: String,
    },
    title: {
      default: null,
      type: String,
    },
    imgSrc: {
      default: null,
      type: String,
    },
    border: {
      default: null,
      type: String,
    },
    boxShadow: {
      default: null,
      type: String,
    },
    contentNoBorder: {
      default: 'false',
      type: String,
    },
    borderColor: {
      default: undefined,
      type: String,
    },
    imgHeight: {
      default: null,
      type: String,
    },
    imgObjectFit: {
      default: 'cover',
      type: String,
    },
    height: {
      default: null,
      type: String,
    },
    url: {
      default: null,
      type: String,
    },
  },
  computed: {
    /**
     * We should then add the border-radius to the image
     */
    borderRadius() {
      return {
        '--borderRadius': this.radius,
      }
    },
    thisBorderColor() {
      return {
        '--thisBorderColor': this.borderColor,
      }
    },
    /**
     * Height of an image
     */
    imageHeight() {
      return {
        '--cardImageHeight': this.imgHeight,
      }
    },
    /**
     * Object fit of an image
     */
    imageObjectFit() {
      return {
        '--cardimgObjectFit': this.imgObjectFit,
      }
    },
  },
  methods: {
    toSingle: function(url) {
      this.$router.push({ path: url })
    },
  },
}
</script>

<template>
  <div>
    <component
      :is="tag"
      class="card mb-2"
      :class="[
        $style.card,
        $style.borderRadius,
        contentNoBorder === 'true' ? $style.contentNoBorder : '',
        height === 'stretch' ? 'h-100' : '',
      ]"
      :style="[
        {
          border: border !== null ? border : '',
          boxShadow: boxShadow !== null ? boxShadow : '',
        },
        borderRadius,
        thisBorderColor,
        imageObjectFit,
        imageHeight !== null ? imageHeight : '',
      ]"
      @click="toSingle(url)"
    >
      <img
        v-if="imgSrc !== null"
        v-lazy="imgSrc"
        :alt="title"
        class="img-top"
      />
      <div class="card-body">
        <slot />
      </div>
    </component>
  </div>
</template>

<style lang="scss" module scoped>
@import '@design';
.card {
  border-color: var(--thisBorderColor);
  border-radius: var(--borderRadius);
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: $medium;
    cursor: pointer;
  }
  &*:focus {
    outline: none;
  }
  img:first-child {
    width: 100%;
    height: var(--cardImageHeight);
    object-fit: var(--cardimgObjectFit);
    border-top-left-radius: var(--borderRadius);
    border-top-right-radius: var(--borderRadius);
  }
  .borderRadius {
    border-color: var(--thisBorderColor);
    border-radius: var(--borderRadius);

    img:first-child {
      width: 100%;
      height: var(--cardImageHeight);
      object-fit: var(--cardimgObjectFit);
      border-color: var(--thisBorderColor);
      border-top-left-radius: var(--borderRadius);
      border-top-right-radius: var(--borderRadius);
    }
  }
  &.contentNoBorder {
    img:first-child {
      width: 100%;
      height: var(--cardImageHeight);
      object-fit: var(--cardimgObjectFit);
      border: 1px solid var(--thisBorderColor);
      border-radius: var(--borderRadius);
    }

    border: none;
  }
}

@media only screen and (max-width: $mobile-sm) {
  .card {
    img:first-child {
      height: auto !important;
    }
  }
}
</style>
